shadow$provide[425] = function(require,module,exports) {

};